const referralCodeMap: Record<string, string> = {
  theunban: '더운반',
  youngwoonmo: '영운모',
};

export const getReferralCode = (partnerCode: string): string => {
  return referralCodeMap[partnerCode] || '';
};
